<template>
    <div>
        <table class="table table-sm table__channel__info">
            <caption>{{ $t('words.detail_information') }}</caption>
            <tbody>
                <tr>
                    <td class="thead">{{ $t('words.title') }}</td>
                    <td>{{ channel.title }}</td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.live_counts') }}</td>
                    <td>{{ channel.ended_live_broadcast_count }}</td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.is_shared') }}</td>
                    <td>
                        <i v-if="!channel.is_shared" :class="{icon: true, 'icon-lock': true}"></i>
                        <span v-if="channel.is_shared">{{ $t('words.open')}}</span>
                        <span v-else>{{ $t('words.not_open')}}</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <table class="table table-sm table__channel__info">
            <caption>{{ $t('words.creator_information') }}</caption>
            <tbody>
                <tr>
                    <td class="thead">{{ $t('words.all_creators') }}</td>
                    <td>{{ renderCreators }}</td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.onair_creator') }}</td>
                    <td><span v-if="isOnAir">{{ this.channel.latest_live_media_broadcast.live_creator.nickname }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.broardcast_ip_address') }}</td>
                    <td><span v-if="isOnAir">{{ this.channel.latest_live_media_broadcast.shooter.ip }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.broadcast_started_at') }}</td>
                    <td><span v-if="isOnAir">{{ this.channel.latest_live_media_broadcast.started_at|moment('YYYY-MM-DD HH:mm:ss') }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr>
                    <td class="thead">{{ $t('words.broadcast_location') }}</td>
                    <td><span v-if="isOnAir">{{ this.channel.latest_live_media_broadcast.shooter.location }}</span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <!--<tr>-->
                    <!--<td class="thead">Agent</td>-->
                    <!--<td><span v-if="isOnAir"></span>-->
                        <!--<span v-else>-</span>-->
                    <!--</td>-->
                <!--</tr>-->
            </tbody>
        </table>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        channel: {
            type: [Object],
            require: true,
        },
    },
    data() {
        return {
            creators: {},
            meta: {
                errors: {},
            },
        };
    },
    methods: {
        initialDatas() {
            this.meta.errors = {};
            this.loadCreator();
        },
        loadCreator() {
            axios.get('/cms/creator/creators').then((response) => {
                this.creators = response.data.data;
            }).catch((error) => {
                // console.log(error);
                this.meta.errors = error.response.data.errors;
            });
        },
        changeChannel(data) {
            this.$emit('changeChannel', data);
        },
    },
    computed: {
        ...mapGetters([
            'selectedServiceAccount',
        ]),
        // channelApi() {
        //     return `/cms/creator/channels/${this.channel.id}`;
        // },
        isOnAir() {
            return 'latest_live_media_broadcast' in this.channel
                && 'is_onair' in this.channel.latest_live_media_broadcast
                && this.channel.latest_live_media_broadcast.is_onair;
        },
        renderCreators() {
            return _.map(this.creators, 'nickname').join(', ');
        },
    },
    watch: {
        channel(newValue, oldValue) {
            if (typeof oldValue.id === 'undefined') {
                this.initialDatas();
            }
        },
    },
};
</script>

<style>
    .thead {
        width: 50%;
    }
    .table__channel__info .thead {
        width: 200px;
    }
</style>
